'use es6';

import * as FieldTranslator from '../FieldTranslator';
import { DATE, DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import { deref, unwatch, watch } from 'atom';
import { isResolved } from 'reference-resolvers/utils';
import After from 'customer-data-filters/filterQueryFormat/operator/After';
import Before from 'customer-data-filters/filterQueryFormat/operator/Before';
import FilterOperatorPropertyInputOption from './FilterOperatorPropertyInputOption';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ReferenceResolverType from 'reference-resolvers/schema/ReferenceResolverType';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UISelect from 'UIComponents/input/UISelect';
import UIFormControl from 'UIComponents/form/UIFormControl';
import I18n from 'I18n';
import FilterOperatorErrorType from '../propTypes/FilterOperatorErrorType';
import { jsx as _jsx } from "react/jsx-runtime";
class FilterOperatorPropertyInput extends Component {
  constructor() {
    super();
    this.onOpenChange = evt => {
      this.setState({
        isOpen: evt.target.value
      });
      if (evt.target.value === false && this.props.onBlur) {
        this.props.onBlur();
      }
    };
    this.handleChange = ({
      target: {
        value: nextValue
      }
    }) => {
      const {
        fieldName,
        onChange,
        value
      } = this.props;
      let updatedValue;
      if (value.constructor === After || value.constructor === Before) {
        var _this$state$options$f;
        const optionType = (_this$state$options$f = this.state.options.find(o => o.value === nextValue)) === null || _this$state$options$f === void 0 ? void 0 : _this$state$options$f.type;
        updatedValue = value.merge({
          [fieldName]: nextValue,
          referencedPropertyType: optionType
        });
      } else {
        updatedValue = value.merge({
          [fieldName]: nextValue
        });
      }
      const onChangeEvent = SyntheticEvent(updatedValue);
      onChange(onChangeEvent, this.state.isOpen);
    };
    this.handleOptionsChange = referenceRecords => {
      const {
        filterFamily
      } = this.props;
      if (isResolved(referenceRecords)) {
        const options = referenceRecords.filter(record => !record.referencedObject.get('hidden')).map(record => {
          const propertyDescription = record.getIn(['referencedObject', 'description']);
          const propertyName = record.id;
          const helpText = FieldTranslator.getTranslatedFieldDescription({
            fieldDescription: propertyDescription,
            fieldName: propertyName,
            filterFamily
          });
          const label = record.label || propertyName;
          return {
            value: propertyName,
            text: label,
            help: helpText,
            type: record.getIn(['referencedObject', 'type'])
          };
        }).toArray();
        this.setState({
          loading: false,
          options
        });
      }
    };
    this.state = {
      loading: true,
      options: [],
      isOpen: false
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    const {
      resolver
    } = this.props;
    if (resolver && resolver.all) {
      this.referenceAtom = resolver.all();
      watch(this.referenceAtom, this.handleOptionsChange);
      this.handleOptionsChange(deref(this.referenceAtom));
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleOptionsChange);
    }
  }
  focus() {
    this.input.focus();
  }
  getOptions() {
    const {
      value
    } = this.props;
    let options = this.state.options;
    if (value instanceof After || value instanceof Before) {
      options = options.filter(option => option.type === DATE_TIME || option.type === DATE);
    }
    const selectedFilterFieldOption = options.find(o => o.value === value.field.name);
    if (selectedFilterFieldOption) {
      selectedFilterFieldOption.disabled = true;
    }
    return options;
  }
  render() {
    const {
      className,
      fieldName,
      placeholder,
      value,
      error
    } = this.props;
    const isError = error.get('error');
    const errorMessage = error.get('message');
    return /*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(UISelect, {
        className: className,
        error: this.state.loading ? false : undefined,
        itemComponent: FilterOperatorPropertyInputOption,
        onChange: this.handleChange,
        onOpenChange: this.onOpenChange,
        options: this.getOptions(),
        placeholder: placeholder,
        ref: component => this.input = component,
        value: value.get(fieldName)
      })
    });
  }
}
FilterOperatorPropertyInput.defaultProps = {
  fieldName: 'value'
};
FilterOperatorPropertyInput.propTypes = {
  className: PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  fieldName: PropTypes.string.isRequired,
  filterFamily: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  resolver: ReferenceResolverType,
  value: FilterOperatorType.isRequired
};
export default FilterOperatorPropertyInput;